import httpClient from "../httpClient";
import httpClientPublic from "../httpClientPublic";
import { TokenService } from "../storage.service";

const END_POINT = "Account";

class AccountService {
  async login(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/login`,
      data: params,
    };

    const response = await httpClientPublic(config);

    if (response && response?.data) {
      const { accessToken, refreshToken } = response.data;

      if (accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);
      }
    }

    return response.data || {};
  }

  async logout() {
    const params = {
      refreshToken: TokenService.getRefreshToken(),
    };

    const config = {
      method: "post",
      url: `${END_POINT}/logout`,
      data: params,
    };

    const response = await httpClient(config);

    TokenService.removeToken();
    TokenService.removeRefreshToken();

    return response || {};
  }

  async refreshToken() {
    const config = {
      method: "post",
      url: `${END_POINT}/refreshToken`,
      data: {
        RefreshToken: TokenService.getRefreshToken(),
      },
      headers: {
        Authorization: null,
      },
    };
    const response = await httpClient(config);

    if (response && response.data) {
      const { accessToken, refreshToken } = response.data;
      if (accessToken && refreshToken) {
        TokenService.saveToken(accessToken);
        TokenService.saveRefreshToken(refreshToken);
      }
    }

    return response.data;
  }

  async postCreateUser(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/createUser`,
      data: params,
    };

    const response = await httpClient(config);
    return response || {};
  }

  async postUpdateUser(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/updateUser`,
      data: params,
    };

    const response = await httpClient(config);
    return response || {};
  }

  async postDeleteUser(params) {
    const config = {
      method: "post",
      url: `${END_POINT}/deleteUser`,
      params: params,
    };

    const response = await httpClient(config);
    return response || {};
  }

  async getProfile() {
    const config = {
      method: "get",
      url: `${END_POINT}/getProfile`,
    };

    const response = await httpClient(config);
    return response?.data || {};
  }
}

export default new AccountService();
